<template>
  <div id="classdetail">
    <div class="video"></div>
    <div class="main">
      <div class="tag">新品</div>
      <h2>
        <b>面试1对1私塾班</b>
        <span>¥3980</span>
      </h2>
      <div class="subtitle">
        <span>2018.12.03-2018.12.0</span>
        <span>已有297人购买</span>
      </div>
      <!--赠送-->
      <div class="gift">
        <a href="">
          <span class="tag"></span>
          <div class="t">
            作文范文集
            <div class="s">3个赠品</div>
          </div>
        </a>
      </div>
      <ul class="nav">
        <li class="active">课程介绍</li>
        <li>课程列表</li>
        <li>授课老师</li>
      </ul>
      <!--课程详情-->
      <div class="detail">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <!--课程介绍-->
            <div class="swiper-slide">
              <img src="../../assets/img/classdetail_class_detail_intro.png" alt="" width="100%">
            </div>
            <!--课程列表-->
            <div class="swiper-slide"></div>
            <!--授课老师-->
            <div class="swiper-slide"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="fix-bar">
      <div class="price">3980</div>
      <div class="pay">
        <a href="">咨询客服</a>
        <a href="">立即购买</a>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
/* eslint-disable no-new */
export default {
  name: 'ClassDetail',
  mounted () {
    new Swiper('#classdetail .detail .swiper-container', {})
  }
}
</script>

<style scoped lang="stylus">
#classdetail
  .video
    width: 7.5rem
    height: 4.4rem
    background: url(../../assets/img/classdetail_video_bg.png) no-repeat center
    -webkit-background-size: 100%
    background-size: 100%
  .main
    & > .tag
      display: block
      width: .72rem
      height: .36rem
      line-height: .36rem
      background-color: #FF7052
      margin: .76rem 0 0 .4rem
      font-size: .24rem
      color: #fff
      text-align: center
      -webkit-border-radius: .04rem
      -moz-border-radius: .04rem
      border-radius: .04rem
    & > h2
      display: flex
      justify-content: space-between
      align-items: center
      margin: .16rem .4rem .04rem
      text-align: left
      b
        font-size: .34rem
        color: #050505
        font-weight: 500
    & > .subtitle
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 .4rem .4rem
      text-align: left
      span
        display: none
        font-size: .22rem
        color: #9DA4B3
    .gift
      position: relative
      display: flex
      justify-content: left
      align-items: center
      height: 1.2rem
      padding: .22rem .4rem
      background-color: #FAFAFA
      margin: .0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      -webkit-border-radius: .2rem
      -moz-border-radius: .2rem
      border-radius: .2rem
      &::before
        content: "赠"
        display: block
        width: .4rem
        height: .4rem
        line-height: .4rem
        border: .01rem solid #FF7052
        -webkit-border-radius: .08rem
        -moz-border-radius: .08rem
        border-radius: .08rem
        font-size: .28rem
        color: #FF7052
        text-align: center
      &::after
        content: ""
        position: absolute
        top: .5rem
        right: .4rem
        display: block
        width: .15rem
        height: .15rem
        border-top: .02rem solid #CFD1D4
        border-right: .02rem solid #CFD1D4
        transform: rotate(45deg)
      .t
        margin-left: .18rem
        font-size: .28rem
        color: #050505
        .s
          font-size: .22rem
          color: #9DA4B3
    ul.nav
      display: flex
      justify-content: space-around
      margin: .4rem auto
      li
        font-size: .36rem
        color: #050505
        &.active
          position: relative
          color: #1E81F2
          &::after
            content: ""
            position: absolute
            bottom: -.08rem
            left: 50%
            display: block
            width: .8rem
            height: .04rem
            background-color: #1E81F2
            margin-left: -.4rem
  #fix-bar
    position: fixed
    bottom: 0
    left: 50%
    z-index: 10000
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: 1.08rem
    padding: 0 .2rem 0 .4rem
    margin: 0 0 0 -3.75rem
    background-color: #fff
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .price
      font-size: .5rem
      color: #FF7052
      &::before
        content: "￥"
        display: inline-block
        font-size: .26rem
        color: #FF7052
    .pay
      display: flex
      width: 4.24rem
      height: .8rem
      overflow: hidden
      -webkit-border-radius: 2rem
      -moz-border-radius: 2rem
      border-radius: 2rem
      a
        display: block
        width: 50%
        height: 100%
        line-height: .8rem
        background-color: #FF7052
        color: #fff
        text-align: center
        &:first-child
          background-color: #FFC452
</style>



// WEBPACK FOOTER //
// src/components/class/ClassDetail.vue